import './styles/base.css';
import { mount } from './utils/dom.js';
import { Header } from './components/header/header.js';
import { Hero } from './components/hero/hero.js';
import { Services } from './components/services/services.js';
import { AiLab } from './components/ai-lab/ai-lab.js';
import { About } from './components/about/about.js';
import { Contact } from './components/contact/contact.js';
import { Footer } from './components/footer/footer.js';

/**
 * Bootstrap the application by mounting every component into #app
 * in the order they should appear on the page.
 *
 * Exported so unit tests can drive the bootstrap with a custom root.
 *
 * @param {HTMLElement} [root]
 */
export function bootstrap(root) {
  const target = root || document.getElementById('app');
  if (!target) throw new Error('bootstrap: #app root element not found');
  target.innerHTML = '';
  mount(target, new Header());
  mount(target, new Hero());
  mount(target, new Services());
  mount(target, new AiLab());
  mount(target, new About());
  mount(target, new Contact());
  mount(target, new Footer());
  return target;
}

// Only auto-bootstrap in a real browser (skip when imported by node-based
// unit tests where `process` is defined).
const isBrowser =
  typeof window !== 'undefined' && typeof process === 'undefined';
if (isBrowser) {
  if (document.readyState !== 'loading') bootstrap();
  else document.addEventListener('DOMContentLoaded', () => bootstrap());
}
